var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26.5,
    height: 26.5,
    rx: 3.78571,
    fill: "#0077FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0383 19.1389C8.00232 19.1389 4.55947 14.7178 4.41602 7.36108H7.43954C7.53886 12.7607 9.76788 15.0479 11.5334 15.5195V7.36108H14.3804V12.018C16.1239 11.8175 17.9557 9.69542 18.5736 7.36108H21.4206C21.1877 8.57174 20.7236 9.71803 20.0571 10.7283C19.3907 11.7385 18.5363 12.591 17.5474 13.2323C18.6512 13.8183 19.6262 14.6477 20.408 15.6659C21.1897 16.684 21.7605 17.8677 22.0827 19.1389H18.9488C18.6596 18.0348 18.0719 17.0465 17.2592 16.2977C16.4465 15.549 15.4451 15.0732 14.3804 14.93V19.1389H14.0383Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.5f27f0fcc1300af708eca8be2abb0113.svg";
export { ForwardRef as ReactComponent };